// ** Modules
import { useRouter } from 'next/router';
import { signIn, type getProviders } from 'next-auth/react';

// ** UI
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';

// ** Components
import Link from '@/components/common/Link';
import Button from '@/components/common/Button';
import Section from '@/components/common/Section';

type LoginRequiredPageProps = {
	providers?: Awaited<ReturnType<typeof getProviders>>;
};

const LoginRequiredPage = ({ providers }: LoginRequiredPageProps) => {
	const router = useRouter();

	const handleLogin = () => {
		// Extract the first provider ID from the map (e.g., 'authentik', 'credentials', etc.)
		const firstProvider = providers ? Object.values(providers)[0] : null;
		if (firstProvider?.id) {
			signIn(firstProvider.id);
		} else {
			signIn(); // Fallback to default sign-in flow
		}
	};

	const handleRedirectHome = () => {
		router.push('/');
	};

	const handleRedirectFormular = () => {
		router.push('/');
	};

	return (
		<Section
			containerSx={{
				minHeight: '83vh',
				alignContent: 'center',
				padding: 18,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: 4,
				textAlign: 'center'
			}}
		>
			<Typography variant="h4-normal">Bitte einloggen</Typography>
			<Typography variant="body-md">Sie müssen eingeloggt sein, um diese Seite anzusehen.</Typography>

			<Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
				<Button variant="contained" color="primary" onClick={handleLogin}>
					Jetzt einloggen
				</Button>
				<Button variant="outlined" color="secondary" onClick={handleRedirectHome}>
					Zur Startseite
				</Button>
			</Stack>

			<Card sx={{ maxWidth: 400, mt: 6 }}>
				<CardContent>
					<Typography variant="h6-normal" gutterBottom>
						Ansprechpartner
					</Typography>
					<Typography variant="body-md">Christine Marriott</Typography>
					<Typography variant="body-md">E-Mail: marriott@tischler.nrw</Typography>
					<Typography variant="body-md">Telefon: 0231 91 20 10 44</Typography>
				</CardContent>
			</Card>

			<Link
				href="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=gswTRUnjSUmRLlbo-rHu238hHY7yhoNLv1z2fPb6_PpUOEwwVjhEWVdCWTRMR1pLNlkxT0FWSFZZSiQlQCN0PWcu"
				target="_blank"
			>
				<Stack direction={{ xs: 'column', sm: 'row' }} sx={{ mt: 6 }} spacing={2}>
					<Button variant="contained" color="primary" onClick={handleRedirectFormular}>
						Umfrage &quot;Zugriff für Inhaber + Mitarbeiter&quot;
					</Button>
				</Stack>
			</Link>
		</Section>
	);
};

export default LoginRequiredPage;
